module.exports = __webpack_public_path__ + "static/media/no_cases.d995a6f2.png";